import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialPointOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {vec3} from "#material/types/vector"

export interface UvMapSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {
        fromInstancer: "boolean" // found in inputs: -; found in settings: bool; inferred from data: boolean
        uv: "vector" // found in inputs: -; found in settings: vector,output; inferred from data: float3,null
        uvMap: "string" // found in inputs: -; found in settings: string; inferred from data: string
    }
    settingsExtensions: {
        uvMapIndex?: number // found in inputs: -; found in settings: integer,scalar; inferred from data: float
    }
    outputs: {
        uv: "point"
    }
}

export const uvMapDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeUVMap,
    },
    nodeClass: "UvMap",
    ui: {
        label: "UV Map",
        color: "#4987af",
        items: [
            {name: "uv", label: "UV", valueType: "point", output: true},
            {
                defaultValue: 0,
                name: "uvMapIndex",
                label: "UV",
                valueType: "int",
                options: [
                    {value: 0, label: "UV"},
                    {value: 1, label: "UV1"},
                    {value: 2, label: "UV2"},
                ],
                input: false,
                setting: true,
                output: false,
            },
        ],
        support: {
            cycles: {
                full: false,
                remark: "Some parameters not supported",
            },
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({uv: materialPointOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({
                fromInstancer: z.optional(z.boolean()),
                uv: z.optional(vec3),
                uvMap: z.optional(z.string()),
                uvMapIndex: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<UvMapSockets>
